export const categories = [
  {
    name: "Arbres",
    items: [{ name: "Palmier", lien: "" }],
  },
  {
    name: "Fruitier",
    items: [
      { name: "orangier", lien: "" },
      { name: "pommier", lien: "" },
      { name: "Jackier", lien: "" },
    ],
  },
  {
    name: "Rosier",
    items: [
      { name: "jaune", lien: "" },
      { name: "rouge", lien: "" },
      { name: "rose", lien: "" },
    ],
  },
  {
    name: "Plantes aromatiques",
    items: [],
  },
];

export const popular = [
  {
    name: "Bouquet",
    lien: "/",
  },
  {
    name: "Manzaraka",
    lien: "/",
  },
  {
    name: "Fruitier",
    lien: "/",
  },
  {
    name: "saint valentin",
    lien: "/",
  },
];
